import React from 'react';
import { Megaphone, Leaf } from 'lucide-react';

// Konsekvent visuell etikett som visar om ett kort/flik/sektion bygger på
// BETALD Meta Ads-data eller ORGANISKT innehåll (FB/IG-inlägg & kommentarer).
// Används genomgående i alla 6 Meta Statistik-flikar för snabb orientering.
export function MetaChannelBadge({ type, label, style }) {
  const isPaid = type === 'paid';
  const Icon = isPaid ? Megaphone : Leaf;
  const text = label || (isPaid ? 'Betald annonsering' : 'Organiskt innehåll');
  return (
    <span
      className={`mstat-badge mstat-badge--${isPaid ? 'paid' : 'organic'}`}
      data-testid={`mstat-channel-badge-${isPaid ? 'paid' : 'organic'}`}
      style={style}
    >
      <Icon size={11} />
      {text}
    </span>
  );
}
